import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import CohortActions from '../containers/CohortActions';
import { closeCohort } from '../actions';
import CohortPanel from '../components/CohortPanel';

export default (urls, access) => ({
  ...tabTemplate('cohort', CohortPanel, matchCodeUrl(urls), CohortActions),
  ...tabCloser('closeCohortTab', closeCohort),
  ...tabIcons('filter'),
  access,
  order: 405,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
});
